import React from 'react';
import { EnergyWaves } from './EnergyWaves';
const coverage = [{
  label: 'Settings',
  body: 'Psych units, hospitals, schools, eldercare, day programs and private practice'
}, {
  label: 'Session flow',
  body: 'Warm-Up → Theme → Develop → Close'
}, {
  label: 'The group year',
  body: 'Arrive → ground → express → relate → energize → transition and close'
}, {
  label: 'Every body',
  body: 'Standing, seated and wheelchair versions of every move'
}, {
  label: 'In the room',
  body: 'Invitation wording, what to watch for and “If the group…” routes'
}, {
  label: 'Formats',
  body: 'Printable session cards, 24 worksheets and a field card per volume'
}];
const dial: {
  level: string;
  name: string;
  body: string;
  waves: 1 | 2 | 3;
}[] = [{
  level: 'Low',
  name: 'Quiet room',
  body: 'Slower, smaller, more invitation for a flat or withdrawn group',
  waves: 1
}, {
  level: 'Steady',
  name: 'Present room',
  body: 'The session as written, for a group that is here and ready',
  waves: 2
}, {
  level: 'High',
  name: 'Restless room',
  body: 'Rhythm and structure that give a loud room somewhere to go',
  waves: 3
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-shuttle bg-court-deep" data-id="element-250" data-mp="1f06ffvf95n15">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-251" data-mp="1os2nnzb1ytj3">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-shuttle-soft" data-id="element-252" data-mp="1ou6qsf14noib">
          The method
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold text-white text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-253" data-mp="w35843y87au1">
          The Responsive Session Arc
        </h2>
        <p className="mx-auto mt-2 font-display text-lg italic text-shuttle-soft sm:text-xl" data-id="element-254" data-mp="162w3s8yivvvp">
          A plan that bends to whoever walks in.
        </p>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/90" data-id="element-255" data-mp="2ckasuhyo3g77">
          Every session follows one arc you&apos;ll know by heart: Warm-Up,
          Theme, Develop, Close. Inside every phase there are two tools that let
          you respond to the room instead of imposing on it, the Energy Dial and
          the Seated Swap. It isn&apos;t a script to follow. It&apos;s a set of
          routes for whatever the group brings today.
        </p>

        <div className="mt-8 grid gap-2.5 sm:grid-cols-3" data-id="element-256" data-mp="1wsi68g4929n4">
          {dial.map(d => <div key={d.level} className="rounded-xl bg-white px-4 py-4 text-left shadow-card" data-id="element-257" data-mp="193623uns4rro">
              <div className="flex items-center justify-between" data-id="element-258" data-mp="144mc9j62evu1">
                <span className="font-display text-lg font-bold text-ink" data-id="element-259" data-mp="1isplr2jbgpnl">
                  {d.level} · {d.name}
                </span>
                <span className="text-shuttle-deep" aria-label={`${d.waves} wave${d.waves > 1 ? 's' : ''}`} data-id="element-260" data-mp="1dzwg8cg0xdag">
                  <EnergyWaves count={d.waves} data-id="element-261" data-mp="qa24xzbcrwsb" />
                </span>
              </div>
              <p className="mt-1 text-sm text-ink-soft" data-id="element-262" data-mp="lcad15apkao4">{d.body}</p>
            </div>)}
        </div>
        <p className="mt-3 text-[13px] font-semibold text-white/85" data-id="element-263" data-mp="2wyuc6vxvg8zs">
          The Energy Dial: read the room in 60 seconds, pick the version that fits.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-264" data-mp="2n30ruqdwvb7g">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-white/20 bg-white/10 px-4 py-3" data-id="element-265" data-mp="2s1ls2pt5xuvw">
              <span className="block text-[11px] font-bold uppercase tracking-widest text-shuttle-soft" data-id="element-266" data-mp="3kpq3zt2bv471">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white" data-id="element-267" data-mp="36pf7a9ec6vdy">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}